import { render, staticRenderFns } from "./OctMenu.vue?vue&type=template&id=282ba537&scoped=true&"
import script from "./OctMenu.vue?vue&type=script&lang=js&"
export * from "./OctMenu.vue?vue&type=script&lang=js&"
import style0 from "./OctMenu.vue?vue&type=style&index=0&id=282ba537&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ba537",
  null
  
)

export default component.exports